import Vue from 'vue'
import Router from 'vue-router'
// ***************************  首页 start  *******************************
const home = r => require.ensure([], () => r(require('@/components/home/home')), 'home')
const course_redemption = r => require.ensure([], () => r(require('@/components/home/course_redemption')), 'course_redemption')
// ***************************  首页 end  *******************************

// ***************************  个人中心 start  *******************************
const accountSet = r => require.ensure([], () => r(require('@/components/personal/account_set')), 'accountSet')
// ***************************  个人中心 end  *******************************

// ***************************  科学视频 start  *******************************
const video_home = r => require.ensure([], () => r(require('@/components/scientific_video/video_home')), 'video_home')
const video_class_list = r => require.ensure([], () => r(require('@/components/scientific_video/video_class_list')), 'video_class_list')
const video_detail = r => require.ensure([], () => r(require('@/components/scientific_video/video_detail_play')), 'video_detail')
// ***************************  科学视频 end  *******************************

// ***************************  论坛 start  *******************************
const forum_home = r => require.ensure([], () => r(require('@/components/forum/forum_home')), 'forum_home')
// ***************************  论坛 end  *******************************

// ***************************  新闻中心 start  *******************************
const news_center = r => require.ensure([], () => r(require('@/components/news_center/news_center')), 'news_center')
const news_detail_cpn = r => require.ensure([], () => r(require('@/components/news_center/news_detail_cpn')), 'news_detail_cpn')
// ***************************  新闻中心 end  *******************************

// ***************************  登录注册 start  *******************************
const forget_password = r => require.ensure([], () => r(require('@/components/login/forget_password')), 'forget_password')
// ***************************  登录注册 end  *******************************

// ***************************  课程体系 start  *******************************
const course_home = r => require.ensure([], () => r(require('@/components/course_system/course_home')), 'course_home')
// ***************************  课程体系 end  *******************************

// ***************************  轻课专题页 start  *******************************
const light_course = r => require.ensure([], () => r(require('@/components/home/light_course')), 'light_course')
// ***************************  轻课专题页 end  *******************************

// ***************************  商城 start  *******************************
const course_store = r => require.ensure([], () => r(require('@/components/mars_box_store/mars_course_frame')), 'course_store')
const marsbox_store = r => require.ensure([], () => r(require('@/components/mars_box_store/mars_box_frame')), 'marsbox_store')
const product_detail_frame = r => require.ensure([], () => r(require('@/components/mars_box_store/common/product_detail_frame')), 'product_detail_frame')
const my_order = r => require.ensure([], () => r(require('@/components/mars_box_store/my_order/my_order')), 'my_order')
const shopping_cart_frame = r => require.ensure([], () => r(require('@/components/mars_box_store/shopping_cart_frame')), 'shopping_cart_frame')
const my_order_detail = r => require.ensure([], () => r(require('@/components/mars_box_store/my_order/my_order_detail')), 'my_order_detail')
const settle_accounts_frame = r => require.ensure([], () => r(require('@/components/mars_box_store/settle_accounts_frame')), 'settle_accounts_frame')
const view_logistics_frame = r => require.ensure([], () => r(require('@/components/mars_box_store/view_logistics_frame')), 'view_logistics_frame')
const address_management_frame = r => require.ensure([], () => r(require('@/components/mars_box_store/address_management_frame')), 'address_management_frame')
const refund_frame = r => require.ensure([], () => r(require('@/components/mars_box_store/refund/refund_frame')), 'refund_frame')
const refund_detail_frame = r => require.ensure([], () => r(require('@/components/mars_box_store/refund/refund_detail_frame')), 'refund_frame')
const apply_bill = r => require.ensure([], () => r(require('@/components/mars_box_store/apply_for_billing_cpn')), 'apply_bill')
const invoice_detail = r => require.ensure([], () => r(require('@/components/mars_box_store/invoice_info')), 'invoice_detail')
// ***************************  商城 end  *******************************

// ***************************  机构 start  *******************************
const ins_course_home = r => require.ensure([], () => r(require('@/components/ins_entrance/ins_course_home')), 'ins_course_home')
const ins_course_detail = r => require.ensure([], () => r(require('@/components/ins_entrance/ins_course_detail')), 'ins_course_detail')
const ins_teacher_home = r => require.ensure([], () => r(require('@/components/ins_entrance/ins_teacher_home')), 'ins_teacher_home')
const forum_detail = r => require.ensure([], () => r(require('@/components/forum/forum_detail')), 'forum_detail')
const my_post = r => require.ensure([], () => r(require('@/components/personal/my_post')), 'my_post')
const my_reply = r => require.ensure([], () => r(require('@/components/ins_entrance/my_reply')), 'home')
// ***************************  机构 end  *******************************
const apply_text = r => require.ensure([], () => r(require('@/components/mars_box_store/applyText')), 'apply_text')
// ***************************  关于我们  start *******************************
const about_home = r => require.ensure([], () => r(require('@/components/about_us/about_home')), 'about_home')
// ***************************  关于我们  end *******************************

// ***************************  机构管理  start *******************************
const ins_management_home = r => require.ensure([], () => r(require('@/components/ins_management/ins_management_home')), 'ins_management_home')
// ***************************  机构管理  end *******************************
// ***************************  编程创作  start *******************************
const scratch_program_home = r => require.ensure([], () => r(require('@/components/scratch_program/scratch_program_home')), 'scratch_program_home')
// ***************************  编程创作  end *******************************
//营业执照
const license = r => require.ensure([], () => r(require('@/components/home/license')),'license')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      name: 'home',
      path: "*",
      component: home
    },
    {
      name: 'home',
      path: "/",
      component: home
    },
    {
      name: 'home',
      path: "/index",
      component: home
    },
    {
      // 轻课专题页
      name: 'light_course',
      path: "/light_course",
      component: light_course
    },
    {
      // 课程体系首页
      name: 'course_home',
      path: "/course_system/course_home",
      component: course_home
    },
    {
      // 课程兑换
      name: 'course_redemption',
      path: "/course_redemption/:type",
      component: course_redemption
    },
    {
      //科学视频
      name: 'video_home',
      path: '/scientific_video/video_home',
      component: video_home,
      meta: {
        keepAlive: true,
        isBack: false,
        isRefresh: false
      }
    },
    {
      //科学视频列表
      name: 'video_home',
      path: '/scientific_video/video_class_list/:type',
      component: video_class_list
    },
    {
      // 科学视频播放页
      name: 'video_home',
      path: '/scientific_video/video_detail/:type',
      component: video_detail
    },
    {
      //新闻中心
      name: 'news_home',
      path: '/news_center/news_center/:type',
      component: news_center,
      meta: {
        keepAlive: true
      }
    },
    {
      //新闻详情
      name: 'news_home',
      path: '/news_center/news_detail_cpn/:type',
      component: news_detail_cpn
    },

    // *******************  个人中心 start  ******************

    {
      // 个人中心
      name: 'personal_center',
      path: '/personal/set/:type/:account_type',
      component: accountSet,
      // meta: {
      //   title: marsclub
      // }
    },

    // *******************  个人中心 end  ******************

    // *******************  登录注册 start  ******************

    {
      // 忘记密码
      name: 'forget_password',
      path: "/login/forget_password",
      component: forget_password
    },

    // *******************  登录注册 start  ******************

    // *******************  论坛 start  ******************
    {
      //论坛首页
      name: 'forum_home',
      path: '/forum/forum_home/:type',
      component: forum_home,
      meta: {
        keepAlive: true
      }
    },
    {
      //帖子详情
      name: 'forum_home',
      path: '/forum/forum_detail/:id',
      component: forum_detail,
    },
    {
      //论坛我回复的帖子
      path: '/forum/personal/my_reply/:type',
      component: my_reply,
    },
    {
      //论坛我回复的帖子
      path: '/forum/personal/my_post/:type',
      component: my_post,
    },

    // *******************  论坛 start  ******************

    // *******************  商城 start  ******************

    {
      // 商城课程
      name: 'course_store',
      path: "/mars_box_store/course_store/:type",
      component: course_store,
      meta: {
        keepAlive: true,
        isBack: false,
        isRefresh: false
      }
    },
    {
      // 商城德阳经开科创
      name: 'marsbox_store',
      path: "/mars_box_store/marsbox_store/:type",
      component: marsbox_store,
      meta: {
        keepAlive: true,
        isBack: false,
        isRefresh: false
      }
    },
    {
      // 商城德阳经开科创商品详情
      name: 'marsbox_store',
      path: "/mars_box_store/marsbox_store/detail/:type",
      component: product_detail_frame
    },
    {
      // 商城德阳经开科创课程商品详情
      name: 'course_store',
      path: "/mars_box_store/course_store/detail/:type",
      component: product_detail_frame
    },
    {
      // 商城我的订单
      name: 'my_order',
      path: "/mars_box_store/my_order/:type",
      component: my_order,
      meta: {
        keepAlive: true,
        isBack: false,
        isRefresh: false
      }
    },
    {
      // 商城我的订单详情
      name: 'my_order',
      path: "/mars_box_store/my_order/detail/:type",
      component: my_order_detail
    },
    {
      // 购物车页面
      name: 'shopping_cart_frame',
      path: "/mars_box_store/shopping_cart_frame/:type",
      component: shopping_cart_frame
    },
    {
      // 结算中心页面
      name: 'settle_accounts_frame',
      path: "/mars_box_store/settle_accounts_frame/:type",
      component: settle_accounts_frame
    },
    {
      // 查看物流页面
      name: 'my_order',
      path: "/mars_box_store/view_logistics_frame/:type",
      component: view_logistics_frame
    },
    {
      // 地址管理页面
      name: 'address_management_frame',
      path: "/mars_box_store/address_management_frame/:type",
      component: address_management_frame
    },
    {
      // 退款退货页面
      name: 'my_order',
      path: "/mars_box_store/refund_frame/:type",
      component: refund_frame
    },
    {
      // 售后订单详情-退款退货页面
      name: 'my_order',
      path: "/mars_box_store/refund_detail_frame/:type",
      component: refund_detail_frame
    },
    {
      // 售后订单详情-退款退货页面
      name: 'my_order',
      path: "/mars_box_store/apply_text",
      component: apply_text
    },
    {
      // 申请开票
      name: 'my_order',
      path: "/mars_box_store/my_order/apply_bill/:type",
      component: apply_bill
    },
    {
      // 开票详情
      name: 'invoice_detail',
      path: "/mars_box_store/my_order/invoice_detail/:type",
      component: invoice_detail
    },

    // *******************  商城 end  ******************

    // *********************  课程 start ********************

    {
      //课程首页
      name: 'ins_course_home',
      path: '/mars_box_ins/ins_entrance/ins_course_home/:type/:isCourseDetail',
      component: ins_course_home,
      meta: {
        keepAlive: true,
        isBack: false,
        isRefresh: false
      }
    },
    {
      //课程详情页
      name: 'course_detail_list',
      path: '/mars_box_ins/ins_entrance/ins_course_detail/:type/:name/:isCourseDetail',
      component: ins_course_detail,
      // meta: {
      //   requireAuth: true,
      //   authority: true,
      //   title: marsclub
      // }
    },
    {
      //机构教师入口
      name: 'teacher_forum',
      path: '/mars_box_ins/ins_entrance/ins_teacher_home/:type/:forum_type',
      component: ins_teacher_home,
      meta: {
        keepAlive: true
      }
    },
    {
      //机构帖子详情
      name: 'teacher_forum_detail',
      path: '/mars_box_ins/ins_teacher_home/forum_detail/:type',
      component: forum_detail,
      // meta: {
      //   title: marsclub,
      //   requireAuth: true,
      //   authority: true
      // }
    },
    {
      //我的帖子
      path: '/mars_box_ins/personal/my_post/:type',
      component: my_post,
    },
    {
      //机构入口我回复的帖子
      path: '/mars_box_ins/personal/my_reply/:type',
      component: my_reply,
    },

    // *********************  课程 end  *************************

    // *********************  编程创作 start ********************

    {
      // 编程创作首页
      name: 'ins_scratch',
      path: "/ins_scratch/:type",
      component: scratch_program_home
    },
  
    // *********************  编程创作 end  *************************

    // *********************  机构管理 start ********************

    {
      // 机构管理首页
      name: 'ins_management',
      path: "/ins_management/:type/:class",
      component: ins_management_home
    },

    // *********************  机构管理 end  *************************

    // *********************  关于我们 start  *************************
    {
      //关于我们首页
      name: 'about_home',
      path: '/about_us/about_home/:type',
      component: about_home
    },
    // *********************  关于我们 end  *************************
    {
      //营业执照
      path:'/web/home/license',
      component: license,
    },
  ],
  scrollBehavior(to, from) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js